import axiosInstance from '../../config/axiosInstance';
import {
  AppNotification,
  NotificationsPaginated,
  NotificationsQueryFilters,
} from '../../types/notification';

class NotificationService {
  private readonly BASE = '/app-notifications';

  async getNotifications(
    page = 1,
    pageSize = 20,
    filters?: NotificationsQueryFilters,
  ): Promise<NotificationsPaginated> {
    return axiosInstance.get(this.BASE, {
      params: {
        page,
        pageSize,
        unreadOnly: filters?.unreadOnly ? true : undefined,
        // Comma-joined so NestJS receives a single `types` param it can split.
        types: filters?.types && filters.types.length > 0 ? filters.types.join(',') : undefined,
        startDate: filters?.startDate,
        endDate: filters?.endDate,
      },
    });
  }

  async getUnreadCount(): Promise<{ count: number }> {
    return axiosInstance.get(`${this.BASE}/unread-count`);
  }

  async markAsRead(id: string): Promise<AppNotification> {
    return axiosInstance.patch(`${this.BASE}/${id}/read`);
  }

  async markAllAsRead(): Promise<void> {
    return axiosInstance.patch(`${this.BASE}/read-all`);
  }

  async broadcast(title: string, message: string): Promise<{ sent: number }> {
    return axiosInstance.post(`${this.BASE}/broadcast`, { title, message });
  }
}

export const notificationService = new NotificationService();
